module.exports = __webpack_public_path__ + "img/img39.2aa5ea0b.png";